export const formatToComma = (num: number): string => {
    return num.toLocaleString('en-US')
}